import { Edge, EdgeMarker, MarkerType, Project } from 'reactflow';
import { Theme } from '@material-ui/core';
import { PROTOTYPE_NODE_ID } from '../ReactFlow/nodes/PrototypeNode/PrototypeNode';
import { BUSINESS_CONCEPTS_NODE_ID } from '../ReactFlow/nodes/BusinessConcepts/BusinessConcepts';
import { DATA_SOURCES_NODE_ID } from '../ReactFlow/nodes/DataSources/DataSources';
import { PROTOTYPE_EDGE_ID } from '../ReactFlow/edges/PrototypeEdge';

const BASE_EDGE_PROPS = {
  type: PROTOTYPE_EDGE_ID,
  focusable: false,
};

const BASE_MARKER: EdgeMarker = {
  type: MarkerType.ArrowClosed,
  width: 10,
  height: 10,
};

export const buildPrototypeNodes = (
  viewportHeight: number,
  viewportWidth: number,
  verticalOffset: number,
  hexagonSize: number,
  reactFlowProject: Project,
) => {
  // how much the sidecards (data sources, business concepts) are wide
  const sectionWidth = viewportWidth / 4;
  const { x, y } = reactFlowProject({
    x: viewportWidth / 2 - hexagonSize / 2,
    y: (viewportHeight - verticalOffset) / 2 - hexagonSize / 2 + verticalOffset,
  });

  return [
    {
      id: PROTOTYPE_NODE_ID,
      position: { x, y },
      data: {},
      type: PROTOTYPE_NODE_ID,
    },
    {
      id: BUSINESS_CONCEPTS_NODE_ID,
      position: reactFlowProject({
        x: viewportWidth - sectionWidth,
        y: verticalOffset,
      }),
      data: {
        style: {
          height: viewportHeight - verticalOffset,
          width: sectionWidth,
        },
      },
      type: BUSINESS_CONCEPTS_NODE_ID,
    },
    {
      id: DATA_SOURCES_NODE_ID,
      position: reactFlowProject({ x: 0, y: verticalOffset }),
      data: {
        style: {
          height: viewportHeight - verticalOffset,
          width: sectionWidth,
        },
      },
      type: DATA_SOURCES_NODE_ID,
    },
  ];
};

export const buildPrototypeEdges = (
  visibleBusinessConcepts: string[],
  visibleDataSources: string[],
  theme: Theme,
) => {
  const edges: Edge[] = [];

  const visibleBusinessConceptsSet = new Set(visibleBusinessConcepts);

  const visibleDataSourcesSet = new Set(visibleDataSources);

  visibleBusinessConceptsSet.forEach(b =>
    edges.push({
      ...BASE_EDGE_PROPS,
      source: PROTOTYPE_NODE_ID,
      target: BUSINESS_CONCEPTS_NODE_ID,
      markerEnd: {
        ...BASE_MARKER,
        color: theme.palette.accentSecondary.main,
      },
      data: { color: theme.palette.accentSecondary.main },
      sourceHandle: 'right',
      targetHandle: b,
      id: `businessConcepts:${b}`,
    }),
  );

  visibleDataSourcesSet.forEach(d =>
    edges.push({
      ...BASE_EDGE_PROPS,
      source: PROTOTYPE_NODE_ID,
      target: DATA_SOURCES_NODE_ID,
      markerEnd: {
        ...BASE_MARKER,
        color: theme.palette.accent.dark,
      },
      data: { color: theme.palette.accent.dark },
      sourceHandle: 'left',
      targetHandle: d,
      id: `dataSources:${d}`,
    }),
  );

  return edges;
};

export const getCenterPositionFromViewportRect = (
  rect: DOMRect,
  verticalOffset = 0,
) => {
  return {
    top: rect.y + rect.height / 2 - verticalOffset,
    left: rect.x + rect.width / 2,
  };
};
